<template>
  <div>
    <Intro v-if="content.data.intro.visible" />
        <Form />
    
  </div>
</template>

<script>
import Intro from "./Intro.vue";
import Form from "./Form.vue";

export default {
  name: "MainPage",
  inject: ["content"],
  data() {
    return {
      title: "home page",
      windowWidth: 0,
    };
  },
  components: {
    Intro,
     Form,
  },

};
</script>
